import { on } from 'delegated-events';
import { scrollToElement } from '../scroll-to-element';

import OptionChooser from '../product-detail/option-chooser';
import Banners from '../product-detail/banners-product-card';
import AmountHandler from '../amount-handler';
import AvailabilityPopup from '../availability-popup';
import DescNavigation from '../desc-navigation';

export default function () {
    Banners();
    OptionChooser();
    AmountHandler();
    AvailabilityPopup();
    DescNavigation();
    ScrollToComments();


    import('@fancyapps/ui').then(({ Fancybox }) => {
        Fancybox.bind('[data-run-fancybox]', {
            autoFocus: false,
            trapFocus: false,
            placeFocusBack: false,
            hideScrollbar: false,
            groupAttr: 'data-run-fancybox'
        });
    });


    // VARIOUS BELOW
    // DETAIL ACCORDION
    on('click', '.detail-accordion-trigger', function () {
        this.classList.toggle('info-visible');
    });

    // DETAIL LOUPE
    on('click', '.detail-loupe', function () {
        const toClick = document.querySelector('.product-images .swiper-slide-active');

        if (toClick) {
            toClick.click();
        }
    });
}

function ScrollToComments() {
    const scrollTrigger = document.querySelector("[data-scroll-to-comments]");
    if (!scrollTrigger) return;
    const target = document.querySelector('#detail-comments');
    if (!target) return;

    scrollTrigger.style.cursor = 'pointer';
    scrollTrigger.addEventListener('click', function () {
        scrollToElement(target);
    });
}